define(
    'views/reset-password',[
        'jquery',
        'utils/view',
        'utils/form-validator',
    ],

    function ($, View, FormValidator) {
        var ResetPasswordView = (function () {

            function ResetPasswordView (container) {
                var _this = this;
                _this.container = container;

                _this.container.find('form').each(function() {
                    _this.initForm($(this));
                });
            }

            ResetPasswordView.prototype.initForm = function ($form) {
                var formValidator = new FormValidator($form);
                formValidator.enableValidMsg(true);
                formValidator.removeInputErrorMsgOn('keypress');
                formValidator.validateInputOn('change');

                $form.on('submit', function(e) {
                    if (! formValidator.validateForm() ) {
                        e.preventDefault();
                    }
                });
            };

            return ResetPasswordView;
        })();

        return View('ResetPassword', function () {
            var view = new ResetPasswordView($('[data-view="ResetPassword"]'));
        });
    }
);
